// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from '@hey-api/client-fetch';
import { client as _heyApiClient } from '../client';
import type {
  AppVersionServiceCheckUpdateData,
  AppVersionServiceCheckUpdateError,
  AppVersionServiceCheckUpdateResponse,
  AppVersionServiceGetLatestAppVersionData,
  AppVersionServiceGetLatestAppVersionError,
  AppVersionServiceGetLatestAppVersionResponse,
  ConfigsAdminCreateData,
  ConfigsAdminCreateError,
  ConfigsAdminCreateResponse,
  ConfigsAdminDeleteData,
  ConfigsAdminDeleteError,
  ConfigsAdminGetData,
  ConfigsAdminGetError,
  ConfigsAdminGetResponse,
  ConfigsAdminListData,
  ConfigsAdminListError,
  ConfigsAdminListResponse,
  ConfigsAdminUpdateData,
  ConfigsAdminUpdateError,
  ConfigsAdminUpdateResponse,
  ConfigsAdminUpdateStatusData,
  ConfigsAdminUpdateStatusError,
  ConfigsAdminVisibleConfigsData,
  ConfigsAdminVisibleConfigsError,
  ConfigsAdminVisibleConfigsResponse,
  CounterCountData,
  CounterCountError,
  FavorsBatchFavoriteData,
  FavorsBatchFavoriteError,
  FavorsDisfavorData,
  FavorsDisfavorError,
  FavorsFavoriteData,
  FavorsFavoriteError,
  FavorsGetFavoriteStatesData,
  FavorsGetFavoriteStatesError,
  FavorsGetFavoriteStatesResponse,
  FavorsGetMyFavoritesData,
  FavorsGetMyFavoritesError,
  FavorsGetMyFavoritesResponse,
  FeedbacksAdminListData,
  FeedbacksAdminListError,
  FeedbacksAdminListResponse,
  FeedbacksCreateData,
  FeedbacksCreateError,
  FilesAdminCreatePublicUploadData,
  FilesAdminCreatePublicUploadError,
  FilesAdminCreatePublicUploadResponse,
  FilesAdminFinishPublicUploadData,
  FilesAdminFinishPublicUploadError,
  FilesAdminFinishPublicUploadResponse,
  FilesAdminGetUploadData,
  FilesAdminGetUploadError,
  FilesAdminGetUploadResponse,
  FilesAdminMoveUploadData,
  FilesAdminMoveUploadError,
  FilesCreateCiPublicUploadData,
  FilesCreateCiPublicUploadError,
  FilesCreateCiPublicUploadResponse,
  FilesCreateUpload2Data,
  FilesCreateUpload2Error,
  FilesCreateUpload2Response,
  FilesCreateUploadData,
  FilesCreateUploadError,
  FilesCreateUploadResponse,
  FilesFinishCiPublicUploadData,
  FilesFinishCiPublicUploadError,
  FilesFinishCiPublicUploadResponse,
  FilesFinishUpload2Data,
  FilesFinishUpload2Error,
  FilesFinishUpload2Response,
  FilesFinishUploadData,
  FilesFinishUploadError,
  FilesFinishUploadResponse,
  FilesGetUploadMetadataData,
  FilesGetUploadMetadataError,
  FilesGetUploadMetadataResponse,
  FilesGetUploadsPresignedUrlData,
  FilesGetUploadsPresignedUrlError,
  FilesGetUploadsPresignedUrlResponse,
  FollowsBatchGetFollowInfosData,
  FollowsBatchGetFollowInfosError,
  FollowsBatchGetFollowInfosResponse,
  FollowsBatchGetFollowStatesData,
  FollowsBatchGetFollowStatesError,
  FollowsBatchGetFollowStatesResponse,
  FollowsFollowData,
  FollowsFollowError,
  FollowsGetMyFollowersData,
  FollowsGetMyFollowersError,
  FollowsGetMyFollowersResponse,
  FollowsGetMyFollowingsData,
  FollowsGetMyFollowingsError,
  FollowsGetMyFollowingsResponse,
  FollowsUnfollowData,
  FollowsUnfollowError,
  PuppetTasksCreatePuppetTaskData,
  PuppetTasksCreatePuppetTaskError,
  PuppetTasksCreatePuppetTaskResponse,
  PuppetTasksGetPuppetTaskData,
  PuppetTasksGetPuppetTaskError,
  PuppetTasksGetPuppetTaskResponse,
  PuppetTasksListPuppetTasksData,
  PuppetTasksListPuppetTasksError,
  PuppetTasksListPuppetTasksResponse,
  VotesAdminCountData,
  VotesAdminCountError,
  VotesAdminCountResponse,
  VotesAdminListData,
  VotesAdminListError,
  VotesAdminListResponse,
  VotesAdminVoteByPuppetData,
  VotesAdminVoteByPuppetError,
  VotesGetMyVotesData,
  VotesGetMyVotesError,
  VotesGetMyVotesResponse,
  VotesGetVoteStatesData,
  VotesGetVoteStatesError,
  VotesGetVoteStatesResponse,
  VotesUnvoteData,
  VotesUnvoteError,
  VotesVoteData,
  VotesVoteError,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * 获取所有配置项
 */
export const configsAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<ConfigsAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ConfigsAdminListResponse, ConfigsAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/configs',
    ...options,
  });
};

/**
 * 创建配置项
 */
export const configsAdminCreate = <ThrowOnError extends boolean = false>(
  options: Options<ConfigsAdminCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<ConfigsAdminCreateResponse, ConfigsAdminCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/configs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 批量获取内测/线上配置项
 */
export const configsAdminVisibleConfigs = <ThrowOnError extends boolean = false>(
  options?: Options<ConfigsAdminVisibleConfigsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ConfigsAdminVisibleConfigsResponse,
    ConfigsAdminVisibleConfigsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/configs/visible',
    ...options,
  });
};

/**
 * 删除配置项
 */
export const configsAdminDelete = <ThrowOnError extends boolean = false>(
  options: Options<ConfigsAdminDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, ConfigsAdminDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/configs/{id}',
    ...options,
  });
};

/**
 * 获取配置项
 */
export const configsAdminGet = <ThrowOnError extends boolean = false>(
  options: Options<ConfigsAdminGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ConfigsAdminGetResponse, ConfigsAdminGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/configs/{id}',
    ...options,
  });
};

/**
 * 更新配置项
 */
export const configsAdminUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ConfigsAdminUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<ConfigsAdminUpdateResponse, ConfigsAdminUpdateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/configs/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 更新配置项状态，上线/内测
 */
export const configsAdminUpdateStatus = <ThrowOnError extends boolean = false>(
  options: Options<ConfigsAdminUpdateStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, ConfigsAdminUpdateStatusError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/configs/{version_id}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const feedbacksAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<FeedbacksAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<FeedbacksAdminListResponse, FeedbacksAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/feedbacks',
    ...options,
  });
};

/**
 * 专用的公共资源上传服务，仅供内部使用，外部用户不可访问
 */
export const filesAdminCreatePublicUpload = <ThrowOnError extends boolean = false>(
  options: Options<FilesAdminCreatePublicUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    FilesAdminCreatePublicUploadResponse,
    FilesAdminCreatePublicUploadError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/files/uploads',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const filesAdminMoveUpload = <ThrowOnError extends boolean = false>(
  options: Options<FilesAdminMoveUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, FilesAdminMoveUploadError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/files/uploads/move',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const filesAdminGetUpload = <ThrowOnError extends boolean = false>(
  options: Options<FilesAdminGetUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<FilesAdminGetUploadResponse, FilesAdminGetUploadError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/files/uploads/{id}',
    ...options,
  });
};

export const filesAdminFinishPublicUpload = <ThrowOnError extends boolean = false>(
  options: Options<FilesAdminFinishPublicUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    FilesAdminFinishPublicUploadResponse,
    FilesAdminFinishPublicUploadError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/files/uploads/{id}/finish',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const votesAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<VotesAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<VotesAdminListResponse, VotesAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/votes',
    ...options,
  });
};

export const votesAdminCount = <ThrowOnError extends boolean = false>(
  options?: Options<VotesAdminCountData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<VotesAdminCountResponse, VotesAdminCountError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/admin/v1/votes/count',
    ...options,
  });
};

/**
 * CI 公共资源上传。调用方必须通过 X-GitLab-OIDC-Token 携带由受信任 GitLab 签发的 ID Token。
 */
export const filesCreateCiPublicUpload = <ThrowOnError extends boolean = false>(
  options: Options<FilesCreateCiPublicUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    FilesCreateCiPublicUploadResponse,
    FilesCreateCiPublicUploadError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/ci/v1/files/public-uploads',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const filesFinishCiPublicUpload = <ThrowOnError extends boolean = false>(
  options: Options<FilesFinishCiPublicUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    FilesFinishCiPublicUploadResponse,
    FilesFinishCiPublicUploadError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/ci/v1/files/public-uploads/{id}/finish',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const appVersionServiceCheckUpdate = <ThrowOnError extends boolean = false>(
  options: Options<AppVersionServiceCheckUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AppVersionServiceCheckUpdateResponse,
    AppVersionServiceCheckUpdateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/appversion/check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const appVersionServiceGetLatestAppVersion = <ThrowOnError extends boolean = false>(
  options?: Options<AppVersionServiceGetLatestAppVersionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    AppVersionServiceGetLatestAppVersionResponse,
    AppVersionServiceGetLatestAppVersionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/appversion/latest',
    ...options,
  });
};

export const counterCount = <ThrowOnError extends boolean = false>(
  options: Options<CounterCountData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, CounterCountError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/counter/{obj_type}/{obj_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const favorsBatchFavorite = <ThrowOnError extends boolean = false>(
  options: Options<FavorsBatchFavoriteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, FavorsBatchFavoriteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/favors/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * get my favorite
 */
export const favorsGetMyFavorites = <ThrowOnError extends boolean = false>(
  options?: Options<FavorsGetMyFavoritesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<FavorsGetMyFavoritesResponse, FavorsGetMyFavoritesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/favors/my-favorites',
    ...options,
  });
};

export const favorsGetFavoriteStates = <ThrowOnError extends boolean = false>(
  options?: Options<FavorsGetFavoriteStatesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    FavorsGetFavoriteStatesResponse,
    FavorsGetFavoriteStatesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/favors/states',
    ...options,
  });
};

/**
 * disfavor
 */
export const favorsDisfavor = <ThrowOnError extends boolean = false>(
  options: Options<FavorsDisfavorData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, FavorsDisfavorError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/favors/{obj_type}/{obj_id}',
    ...options,
  });
};

/**
 * favorite
 */
export const favorsFavorite = <ThrowOnError extends boolean = false>(
  options: Options<FavorsFavoriteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, FavorsFavoriteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/favors/{obj_type}/{obj_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const feedbacksCreate = <ThrowOnError extends boolean = false>(
  options: Options<FeedbacksCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, FeedbacksCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/feedbacks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const filesCreateUpload = <ThrowOnError extends boolean = false>(
  options: Options<FilesCreateUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<FilesCreateUploadResponse, FilesCreateUploadError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/files/uploads',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const filesGetUploadMetadata = <ThrowOnError extends boolean = false>(
  options?: Options<FilesGetUploadMetadataData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    FilesGetUploadMetadataResponse,
    FilesGetUploadMetadataError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/files/uploads/metadata',
    ...options,
  });
};

export const filesGetUploadsPresignedUrl = <ThrowOnError extends boolean = false>(
  options: Options<FilesGetUploadsPresignedUrlData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    FilesGetUploadsPresignedUrlResponse,
    FilesGetUploadsPresignedUrlError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/files/uploads/presigned-urls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const filesFinishUpload = <ThrowOnError extends boolean = false>(
  options: Options<FilesFinishUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<FilesFinishUploadResponse, FilesFinishUploadError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/files/uploads/{id}/finish',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * batch get follow states with optional extra info
 */
export const followsBatchGetFollowInfos = <ThrowOnError extends boolean = false>(
  options: Options<FollowsBatchGetFollowInfosData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    FollowsBatchGetFollowInfosResponse,
    FollowsBatchGetFollowInfosError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/follows/batch-infos',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * get follow states for target users (following or not)
 */
export const followsBatchGetFollowStates = <ThrowOnError extends boolean = false>(
  options?: Options<FollowsBatchGetFollowStatesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    FollowsBatchGetFollowStatesResponse,
    FollowsBatchGetFollowStatesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/follows/batch-states',
    ...options,
  });
};

/**
 * get my followers (users who follow me)
 */
export const followsGetMyFollowers = <ThrowOnError extends boolean = false>(
  options?: Options<FollowsGetMyFollowersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    FollowsGetMyFollowersResponse,
    FollowsGetMyFollowersError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/follows/my-followers',
    ...options,
  });
};

/**
 * get my followings (users I follow)
 */
export const followsGetMyFollowings = <ThrowOnError extends boolean = false>(
  options?: Options<FollowsGetMyFollowingsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    FollowsGetMyFollowingsResponse,
    FollowsGetMyFollowingsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/follows/my-followings',
    ...options,
  });
};

/**
 * unfollow user
 */
export const followsUnfollow = <ThrowOnError extends boolean = false>(
  options: Options<FollowsUnfollowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, FollowsUnfollowError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/follows/{target_uid}',
    ...options,
  });
};

/**
 * follow user
 */
export const followsFollow = <ThrowOnError extends boolean = false>(
  options: Options<FollowsFollowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, FollowsFollowError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/follows/{target_uid}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取 puppet 任务列表
 */
export const puppetTasksListPuppetTasks = <ThrowOnError extends boolean = false>(
  options?: Options<PuppetTasksListPuppetTasksData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    PuppetTasksListPuppetTasksResponse,
    PuppetTasksListPuppetTasksError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/puppet/tasks',
    ...options,
  });
};

/**
 * 创建 puppet 任务
 */
export const puppetTasksCreatePuppetTask = <ThrowOnError extends boolean = false>(
  options: Options<PuppetTasksCreatePuppetTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PuppetTasksCreatePuppetTaskResponse,
    PuppetTasksCreatePuppetTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/puppet/tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取 puppet 任务详情
 */
export const puppetTasksGetPuppetTask = <ThrowOnError extends boolean = false>(
  options: Options<PuppetTasksGetPuppetTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    PuppetTasksGetPuppetTaskResponse,
    PuppetTasksGetPuppetTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/puppet/tasks/{task_id}',
    ...options,
  });
};

export const votesAdminVoteByPuppet = <ThrowOnError extends boolean = false>(
  options: Options<VotesAdminVoteByPuppetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, VotesAdminVoteByPuppetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/votes/puppet',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const votesGetVoteStates = <ThrowOnError extends boolean = false>(
  options?: Options<VotesGetVoteStatesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<VotesGetVoteStatesResponse, VotesGetVoteStatesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/votes/states',
    ...options,
  });
};

/**
 * get my vote
 */
export const votesGetMyVotes = <ThrowOnError extends boolean = false>(
  options?: Options<VotesGetMyVotesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<VotesGetMyVotesResponse, VotesGetMyVotesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/votes/votes',
    ...options,
  });
};

export const votesUnvote = <ThrowOnError extends boolean = false>(options: Options<VotesUnvoteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<unknown, VotesUnvoteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/votes/{obj_type}/{obj_id}',
    ...options,
  });
};

/**
 * vote
 */
export const votesVote = <ThrowOnError extends boolean = false>(options: Options<VotesVoteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<unknown, VotesVoteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v1/votes/{obj_type}/{obj_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const filesCreateUpload2 = <ThrowOnError extends boolean = false>(
  options: Options<FilesCreateUpload2Data, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<FilesCreateUpload2Response, FilesCreateUpload2Error, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v2/files/uploads',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const filesFinishUpload2 = <ThrowOnError extends boolean = false>(
  options: Options<FilesFinishUpload2Data, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<FilesFinishUpload2Response, FilesFinishUpload2Error, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/tools/v2/files/uploads/{id}/finish',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};
